import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useTranslations } from "../../providers/useTranslations";
export const I18n = ({ children = [], defaultValue, options, ...props }) => {
    const { dictionary } = useTranslations();
    const childNodes = children ?? [];
    const interpolations = childNodes instanceof Array ? childNodes : [childNodes];
    const usesDictionary = "t" in props;
    const content = usesDictionary ? dictionary[props.t] : props.content;
    const { removeMissedPlaceholders = true } = options || {};
    if (content === undefined && usesDictionary) {
        console.warn(`No translation found for key ${props.t}`);
        return _jsx(_Fragment, { children: defaultValue || props.t });
    }
    if (interpolations.length === 0) {
        return _jsx(_Fragment, { children: content });
    }
    // split content into parts AND placeholders
    // example: "Hello {0}! You have {1} new messages." => ["Hello ", "{0}", "! You have ", "{1}", " new messages."]
    const contentParts = content.split(/({\d+})/);
    const translatedParts = contentParts.map((part) => {
        // check if part is a placeholder
        const placeholderMatch = part.match(/{(\d+)}/);
        if (placeholderMatch === null) {
            return part;
        }
        const interpolation = interpolations[Number(placeholderMatch[1])];
        if (interpolation === undefined) {
            const translationKey = usesDictionary ? props.t : props.content;
            console.warn(`No interpolation found for placeholder ${placeholderMatch[0]} in translation key ${translationKey}`);
            return removeMissedPlaceholders ? "" : part;
        }
        return interpolation;
    });
    return _jsx(_Fragment, { children: translatedParts });
};
//# sourceMappingURL=I18n.js.map